module.exports = __webpack_public_path__ + "static/media/Helicopter_Control_Room_02.5c2c4f2f.jpg";